import { motion } from "framer-motion";

export const PROCESS_VISUALS = [
  {
    image: "https://customer-assets-39nsmqrw.emergentagent.net/job_integrated-matrix/artifacts/d5r7kph3_abstract_human_figure_with_six_glowing_modality_nodes_connec.png",
    alt: "Whole-person activation shown through connected physiological systems",
    signals: ["Goals", "Sleep", "Energy"],
  },
  {
    image: "https://customer-assets-39nsmqrw.emergentagent.net/job_integrated-matrix/artifacts/lsn146d1_A_sophisticated_wellness_optimization_system_with_interconne.png",
    alt: "Integrated wellness dashboard combining biometrics and performance data",
    signals: ["Labs", "Wearables", "Body data"],
  },
  {
    image: "https://customer-assets-39nsmqrw.emergentagent.net/job_integrated-matrix/artifacts/0i726fcy_An_athletic_illustrated_couple_in_silhouette_undergoing_meta_10.png",
    alt: "Two people visualized through connected physiological systems",
    signals: ["10 domains", "1 CPI", "Connected"],
  },
  {
    image: "https://customer-assets-39nsmqrw.emergentagent.net/job_integrated-matrix/artifacts/8e8kv7d3_An_athletic_illustrated_couple_in_silhouette_undergoing_meta.png",
    alt: "Athletic couple with longitudinal health and performance data overlays",
    signals: ["Baseline", "90 days", "6 months"],
  },
];

export const HowProcessVisual = ({ step }) => {
  const visual = PROCESS_VISUALS[step];
  return (
    <motion.div
      key={visual.image}
      initial={{ opacity: 0.45 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.35 }}
      data-testid={`how-process-visual-${step + 1}`}
      className="relative min-h-[390px] md:min-h-[470px] overflow-hidden"
    >
      <img
        src={visual.image}
        alt={visual.alt}
        data-testid={`how-process-image-${step + 1}`}
        className="absolute inset-0 h-full w-full object-cover object-center"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-foreground via-foreground/10 to-transparent" aria-hidden />
      <div className="absolute inset-x-0 bottom-0 grid grid-cols-3 gap-px bg-white/20">
        {visual.signals.map((signal, index) => (
          <span
            key={signal}
            data-testid={`how-process-signal-${step + 1}-${index + 1}`}
            className="bg-foreground/85 px-2 py-4 text-center font-mono text-xs uppercase tracking-[0.08em] text-white"
          >
            {signal}
          </span>
        ))}
      </div>
    </motion.div>
  );
};